import { render } from "./SArticle.vue?vue&type=template&id=b318e446"
import script from "./SArticle.vue?vue&type=script&lang=js"
export * from "./SArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__